module.exports = __webpack_public_path__ + "static/media/asp.0e4f6f7e.svg";